import script from "./employee-dashboard-minimal-hint.vue?vue&type=script&setup=true&lang=js"
export * from "./employee-dashboard-minimal-hint.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__